import { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import i18n from '../common/i18n';
import { getStoreUrl } from '../../utils/functionUtils';
import { getAppStoreLink, getIosStoreLink } from './home/commons/homeData';
import {
  bodyFont, bodyTextSx, ctaOutlineSx, ctaSx, homeColors, sectionTitleSx,
} from './home/style/homeStyles';

// Si pasado este tiempo seguimos en la página, la redirección no prosperó y mostramos las tiendas.
const REDIRECT_FALLBACK_MS = 2500;

const DownloadApp = () => {
  // 'detecting' mientras corre el init, 'redirecting' si hay tienda, 'manual' como contingencia.
  const [status, setStatus] = useState('detecting');
  const [storeUrl, setStoreUrl] = useState(undefined);

  useEffect(() => {
    let fallbackTimeout;

    // El SO se lee en el efecto y no en render: el user agent sólo existe en el navegador
    // (el prerender no lo tiene) y así cualquier falla termina en la pantalla con las dos tiendas.
    const init = () => {
      try {
        const url = getStoreUrl();

        if (!url) {
          setStatus('manual');
          return;
        }

        setStoreUrl(url);
        setStatus('redirecting');
        window.location.replace(url);
        fallbackTimeout = setTimeout(() => setStatus('manual'), REDIRECT_FALLBACK_MS);
      } catch (error) {
        setStatus('manual');
      }
    };

    init();

    return () => clearTimeout(fallbackTimeout);
  }, []);

  return (
    <>
      <Helmet>
        <title>{i18n.downloadAppTitle}</title>
        {/* Es una pasarela hacia las tiendas, no tiene contenido para indexar. */}
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box
        component="section"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '18px',
          minHeight: '60vh',
          padding: '120px 24px 72px',
          backgroundColor: homeColors.white,
          textAlign: 'center',
        }}
      >
        <Typography component="h1" sx={{ ...sectionTitleSx, fontSize: 28, maxWidth: 520 }}>
          {i18n.downloadAppTitle}
        </Typography>
        <Typography component="p" sx={{ ...bodyTextSx, maxWidth: 460 }}>
          {status === 'manual' ? i18n.downloadAppChooseStore : i18n.downloadAppRedirecting}
        </Typography>
        {status === 'redirecting' && (
          // Salida manual por si el navegador demora o bloquea la redirección automática.
          <Button component="a" href={storeUrl} sx={{ ...ctaSx, fontFamily: bodyFont }}>
            {i18n.downloadAppManualCta}
          </Button>
        )}
        {/* Contingencia: no se pudo resolver la tienda o la redirección no llegó a ocurrir. */}
        {status === 'manual' && (
          <Box sx={{
            display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '12px',
          }}
          >
            <Button
              component="a"
              href={getAppStoreLink()}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ ...ctaSx, fontFamily: bodyFont }}
            >
              {i18n.downloadAppAndroidCta}
            </Button>
            <Button
              component="a"
              href={getIosStoreLink()}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ ...ctaOutlineSx, fontFamily: bodyFont }}
            >
              {i18n.downloadAppIosCta}
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};

export default DownloadApp;
